import { IScope } from "angular";

import { IAssigneeIdMap } from "@gtmhub/assignees/models";
import { ICollection } from "@gtmhub/models";
import { TaskService } from "../services/taskService";
import { ITask } from "../models/models";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { TaskEvents } from "../taskEvents";
import { AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { INgRedux } from "@gtmhub/state-management";

interface IArchivedTasksScope extends IScope {
  assigneesIdMap: IAssigneeIdMap;
  tasks: ICollection<ITask>;
  indicators: {
    loading: boolean;
    unarchiving: boolean;
  };
  unarchive(task: ITask);
}

const bindStateToScope = (state: IAssigneesStoreState) => ({
  assigneesIdMap: state.assignees.map,
});
export class ArchivedTasksCtrl {
  private taskEvents: TaskEvents;

  public static $inject = ["$scope", "TaskService", "UIErrorHandlingService", "AssigneeActions", "$ngRedux"];

  constructor(
    private $scope: IArchivedTasksScope,
    private tasksService: TaskService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private assigneeActions: AssigneeActions,
    private $ngRedux: INgRedux
  ) {
    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(this.$scope);
    this.$scope.$on("$destroy", unsubscribe);

    this.taskEvents = new TaskEvents(this.$scope);

    this.$scope.unarchive = this.unarchive;
    this.$scope.indicators = {
      loading: true,
      unarchiving: false,
    };
    this.init();
  }

  private init = () => {
    this.$ngRedux.dispatch(this.assigneeActions.getAssignees());

    return this.tasksService.getList({ archived: true }).then(
      (tasks) => {
        this.$scope.indicators.loading = false;
        this.$scope.tasks = tasks;
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "loading" })
    );
  };

  private unarchive = (task: ITask) => {
    this.$scope.indicators.unarchiving = true;
    for (let i = 0; i < this.$scope.tasks.items.length; i++) {
      if (this.$scope.tasks.items[i].id === task.id) {
        this.$scope.tasks.items[i].archived = false;
      }
    }
    const update: Partial<ITask> = { archived: false };
    this.tasksService.update(task.id, update).then(
      (task) => {
        this.$scope.indicators.unarchiving = false;
        this.taskEvents.broadcastTaskUpdated({ task, update });

        this.init();
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "unarchiving" })
    );
  };
}
